

export const safeParse = (data) => {
  if ( typeof data == 'object') return data;
  try {
    return JSON.parse(data);
  } catch (error) {
    console.log('parse data error', error)
    return data;
  }
}

export const getLowestPrice = (priceList) => {
  // console.log(priceList)
  let prices = safeParse(priceList);
  let price = parseFloat(prices[0].price);
  let idx = 0;

  for (let i = 1; i < prices.length; i++) {
    if (parseFloat(prices[i].price) < price) {
      idx = i;
    }
  }
  return prices[idx];
};